<script>
import { Bar } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
export default {
  components: {
    hexToRgba,
    CustomTooltips
  },
  extends: Bar,
  props:{
    chartData: {
      type: Object,
      default: {}
    }
  },
  methods:{
    onload(info)
    {
      this.renderChart(
        {
          labels: info.label,
          datasets: info.datasets
        },
        {
          responsive: true,
          maintainAspectRatio: true,
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
              }
            }
          }
        }
      )
    }
  },
  created() {

  },
  mounted () {
    this.onload(this.chartData)
  },
}
</script>
